class TextSwiper {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    const swiperEle = "." + this.el;
    new Swiper(swiperEle, {
      loop: true,
      speed: 10000,
      slidesPerView: 'auto',
      autoplay: {
        delay: 0,
      }
    })
  }
}